import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useRef,useState } from "react";
import nextArrow from "../../assets/nextArrow.png";


import WaitingLoder from "../../Loader/component";

import BottomNarBar from "../../BottomNav/Bottom";
import viewArrow from "../../assets/viewArrow.png";
import '../Orders/orders.css'
import PickupTimer from "./timer";
import AddGoogleNumber from "../Userprofile/AddGoogleNumber";
import GoogleNumberOtpModal from "../Userprofile/GoogleNumberOtpModal";
import GoogleSuccessModal from "../Userprofile/GoogleSuccessModal";


function Orders(props) {
 
  
  const inputRef = useRef(null); 
  const inputOtpRef = useRef(null); 





    useEffect(() => {
      if (props?.otp && inputOtpRef.current) {
        inputOtpRef.current.focus();
      }
    }, [props?.otp]);
  
    // Keep focus on the primary input
    useEffect(() => {
      if (props?.number && inputRef.current) {
        inputRef.current.focus();
      }
    }, [props?.number]);
  
    // Keep focus on the input field after re-renders
  
  const navigate=useNavigate()
  const gotoDetails=(e,order_id)=>{

    
    navigate(`/orders/Details/${order_id}`)
    

  }

    const goToPickUpOrder=(e,order_id)=>{

    
    navigate(`/pickupOptions/${order_id}`)
    

  }


  const viewMoreButtonStyles1 = {
    display: "flex",

    padding: "0px 12px 0px 16px",
    justifyContent: "space-between",
    alignItems: "center",
    alignSelf: "stretch",
    borderRadius: "10px",
    height:"50px",
    border: "1px solid rgba(148, 163, 184, 0.54)",
    background: "green",
  };

    const viewMoreButtonStyles = {
    display: "flex",

    padding: "0px 12px 0px 16px",
    justifyContent: "space-between",
    alignItems: "center",
    alignSelf: "stretch",
    borderRadius: "10px",
    height:"50px",
    border: "1px solid rgba(148, 163, 184, 0.54)",
  
  };

  //console.log("props Orders", props.orderhistory);
  const UserJWTAuth = localStorage.getItem("UserJWTAuth");

  const TopNav = () => {
    return (
      <>
        <div className="_2456r">
          <div className="_3nxa7" data-testid="listing-header-location">
            <button
              className="_1NdRR"
              aria-label="Selected address is Delhi, India; Double tap to change address."
              id="change-address-btn-id"
            >
              <div style={{ display: "flex", "align-items": "center" }}>
                <h2
                  style={{
                    marginLeft: "25px",
                    fontSize: "18px",
                    color: "#583C43",
                    fontWeight:"500"
                  }}
                >
                  Past Orders 
                </h2>

                <div style={{ marginLeft: "10px" }}></div>
              </div>
            </button>

            <span className="icon-Offers-outline _2P0Ff" />
          </div>
        </div>
      </>
    );
  };










useEffect(()=>{

  //console.log("google_OTP_Pop_flag",props&&props.google_OTP_Pop_flag)

},[props&&props.google_OTP_Pop_flag])












//console.log("localStorage.getItem",localStorage.getItem("isGuest")=="true",props&&props.google_Pop_flag&&localStorage.getItem("isGuest")=="true")

  return (
    <div style={{display:"flex",justifyContent:"center"}}>
<>
{/* {props&&props.google_success_flag&&<GoogleSuccess/>} */}
 {(props?.google_success_flag)&&<GoogleSuccessModal/>}
   {(props?.google_OTP_Pop_flag)&&<GoogleNumberOtpModal setOtp={props?.setOtp} otp={props?.otp} googleOtpSubmit={props?.googleOtpSubmit} closeOTpPop={props?.closeOTpPop} google_OTP_Pop_flag={props?.google_OTP_Pop_flag} otpErrorMsg={props?.otpErrorMsg} otpError={props?.otpError} googleAddnumber={props?.googleAddnumber}/>}
{/* {props&&props.google_OTP_Pop_flag&&<AddGoogleNumber/>} */}
    {(props?.google_Pop_flag)&&!(localStorage.getItem("isGuest"))&&<AddGoogleNumber google_Pop_flag={props?.google_Pop_flag}  googleAddnumber={props?.googleAddnumber}closePop={props?.closePop} setNumber={props?.setNumber} number={props?.number} numberError={props?.numberError}numberErrorMsg={props?.numberErrorMsg}/>}
{props&&props.google_Pop_flag&&!(localStorage.getItem("isGuest"))&&<AddGoogleNumber/>}

      <BottomNarBar />
     {/* {props.loader && <WaitingLoder />}  */}
      <TopNav />

      <>
      <BottomNarBar/>
    
    <TopNav/>



<div
          style={{
            background:
              "radial-gradient(circle, rgba(245, 233, 233, 0.408) 0%, rgba(185, 245, 247, 0.34) 100%)",
              //"paddingBottom":Boolean((props.ActiveOrderItems[0])&&(props.ActiveOrderItemsListGlobal[0]))?"12.5rem":Boolean(props.ActiveOrderItems[0])?"9.5rem":props.ActiveOrderItemsListGlobal[0]&&"8.5rem",
          maxWidth:"500px",
          width:"100%"
            }}
          className=" pb-20 pt-20 overflow-y-auto h-screen"

        >
       {props.activeOrderhistory[0] && <h1 style={{padding:"15px"}}>Today's Active Orders</h1>}
    {props.activeOrderhistory && props.activeOrderhistory.map((el, index) => (
  <React.Fragment key={index}>
   {console.log("activeOrderhistory",el)}

    {el?.vendingMachineId>1&&<div style={{padding:"2%"}}>
    <div className=" divBox" style={{ padding:"5%",}}>
      <div  >
      <div style={{padding:"2%"}}>
      <div className="flex justify-between items-center">
        <div>
          <p className="text-lg font-bold text-blue-700 font-roboto font-semibold" style={{color:"#718198",fontSize:"15px"}}>
           PickUp Code:  <span className="orderIdValue " style={{fontSize:"18px"}}>{el.dcCode}</span>
          </p>
        </div>
        <div>
          <p className="text-lg font-bold text-blue-700 font-roboto font-semibold price">₹{el?.amount.toFixed(2)}</p>
        </div>
      </div>
      <div>
        <p className="text-sm text-gray-600 font-roboto address">{el?.vendingMachineAddress}</p>
      </div>
      <div>

      <div className="flex mt-0">
  <p className="text-gray-700 font-roboto text-sm font-medium itemsCount">{el?.lineItems?.length} items</p>
<PickupTimer createdAt={el.createdAt} pickupTime={el.pickupTime} />
</div>
      </div>
    
    </div>

 
    <div className="w-336 h-100  mt-4 flex items-center justify-between">
<div className="relative flex">
  {/* Debugging */}


  {/* Show up to 3 items safely */}
  {el?.lineItems?.slice(0, 3).map((item, index) => (
    <div key={index}>
      <img
        src={`https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/${item.imageUrl}`}
        alt="product"
        style={{
          width: "40px",
          height: "40px",
          padding: "8px",
          marginLeft: "5px",
          border: "1px solid #ccc",
          borderRadius: "9px",
        }}
      />
    </div>
  ))}

  {/* Show +count if more than 3 items */}
  {el?.lineItems?.length > 3 && (
    <div
      style={{
        width: "40px",
        height: "40px",
        padding: "8px",
        marginLeft: "5px",
        border: "1px solid #ccc",
        borderRadius: "9px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "bold",
      }}
      className="countPlus"
    >
      +{el.lineItems.length - 3}
    </div>
  )}
</div>


        <div className="flex flex-col items-center text-blue-700" >
          <div style={viewMoreButtonStyles1}>
            <div onClick={(e)=>{goToPickUpOrder(e,el?.orderId)}} className="viewDetails" style={{color:"black",fontWeight:"500"}}><span>PickUp</span><br/><span>Order</span></div>
            <div  className="viewDetailsIcon">
            <svg  xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z"/></svg>
            </div>
          </div>
        </div>
      </div>
      </div>
      
</div>
</div>}
</React.Fragment>
))}

    <h1 style={{padding:"15px"}}>Past Orders</h1>
    {props.orderhistory && props.orderhistory.map((el, index) => (
  <React.Fragment key={index}>
   

    {el.vendingMachineId>1&&<div style={{padding:"2%"}}>
    <div className=" divBox" style={{ padding:"5%",}}>
      <div  >
      <div style={{padding:"2%"}}>
      <div className="flex justify-between items-center">
        <div>
          <p className="text-lg font-bold text-blue-700 font-roboto font-semibold" style={{color:"#718198",fontSize:"15px"}}>
            Order ID: <span className="orderIdValue " style={{fontSize:"15px"}}>{el.orderId}</span>
          </p>
        </div>
        <div>
          <p className="text-lg font-bold text-blue-700 font-roboto font-semibold price">₹{el.amount.toFixed(2)}</p>
        </div>
      </div>
      <div>
        <p className="text-sm text-gray-600 font-roboto address">{el.vendingMachineAddress}</p>
      </div>
      <div>

      <div className="flex mt-0">
  <p className="text-gray-700 font-roboto text-sm font-medium itemsCount">{el.orderLineItems.length} items</p>
  <h3 className={`text-${el.status === 'cancelled' ? 'red' : 'green-500'} font-roboto text-sm font-medium ml-1`}> • {el.status}</h3>
</div>
      </div>
    
    </div>

 
    <div className="w-336 h-100  mt-4 flex items-center justify-between">
      
        <div className="relative flex ">
        {el.orderLineItems.slice(0, 3).map((e, index) => (
  <div key={index}>
          <img
            style={{ width: "40px", height:"40px", padding: "8px",  "margin-left":"5px",border: "1px solid #ccc",    "border-radius": "9px" }}
            src={`https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/${e.imageUrl}`}
            alt="product"
          />
 
    
           </div>
))}
           {el.orderLineItems.length>3&&<div
            style={{ width: "40px",height:"40px", padding: "8px", "margin-left":"5px",border: "1px solid #ccc","border-radius":"9px",
          
            display: "flex",
            "text-align": "center",
            "align-items": "center",
            "justify-content":"space-around",
          

          }}
          className="countPlus"
            src="https://m.media-amazon.com/images/I/71kOsITKSkL._SX522_.jpg"
            alt="product"
          >+{el.orderLineItems.length-3}</div>}
        </div>

        <div className="flex flex-col items-center text-blue-700">
          <div style={viewMoreButtonStyles}>
            <div onClick={(e)=>{gotoDetails(e,el.orderId)}} className="viewDetails">View Details</div>
            <div  className="viewDetailsIcon">
            <svg  xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z"/></svg>
            </div>
          </div>
        </div>
      </div>
      </div>
      
</div>
</div>}
</React.Fragment>
))}
</div>
    </>
    </>
    </div>
  );
}

export default Orders;
